module.exports = __webpack_public_path__ + "static/img/oilCompany.39aa2fd0.png";